"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getInitialsFromName = ({
  name
}) => {
  let parts = name.split(' ');
  let initials = [];
  parts.map(part => {
    initials.push(part.substr(0, 1).toUpperCase());
  });
  return initials.join('');
};

const UserIcon = ({
  className,
  defaultColor = "#000",
  color,
  label,
  imageUrl,
  name,
  initials
}) => {
  let fill = color || defaultColor;
  let text = label || initials || name && getInitialsFromName({
    name
  });
  fill = (0, _color.default)(fill);
  let contrast;

  if (fill.isDark()) {
    contrast = 'white';
  } else {
    contrast = 'black';
  }

  if (imageUrl) {
    return _react.default.createElement(_SvgIcon.default, {
      className: className,
      title: name
    }, _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
      id: "circle"
    }, _react.default.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "12"
    }))), _react.default.createElement("image", {
      href: imageUrl,
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "xMidYMid slice",
      clipPath: "url(#circle)"
    }), _react.default.createElement("text", {
      x: "12",
      y: "12.5",
      fill: contrast,
      fontFamily: "Akkurat, sans-serif",
      fontSize: "9",
      fontWeight: "normal",
      dominantBaseline: "middle",
      textAnchor: "middle"
    }, text));
  }

  return _react.default.createElement(_SvgIcon.default, {
    className: className,
    title: name
  }, _react.default.createElement("image", {
    href: imageUrl,
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    preserveAspectRatio: "xMinYMin slice"
  }), _react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: fill
  }), _react.default.createElement("text", {
    x: "12",
    y: "12.5",
    fill: contrast,
    fontFamily: "Akkurat, sans-serif",
    fontSize: "9",
    fontWeight: "normal",
    dominantBaseline: "middle",
    textAnchor: "middle"
  }, text));
};

var _default = UserIcon;
exports.default = _default;
module.exports = exports.default;